
export function courrielValide(adresse)
{
    var re = /\S+@\S+\.\S+/;
    return re.test(adresse);
}